import { useCallback } from "react";

import { useSelector } from "react-redux";

import { useRVDispatch } from "../Storage";
import {
    openDialpad as openDialpadAction,
    closeDialpad as closeDialpadAction,
    selectDialpadState,
    GlobalLayoutState,
} from "./GlobalLayoutSlice";

/**
 * Custom hook for managing the global SearchableDialPad modal.
 *
 * @returns Object containing dialpad state and control functions
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { isOpen, defaultPhoneNumber, openDialpad, closeDialpad } = useGlobalDialpad();
 *
 *   return (
 *     <button onClick={() => openDialpad({ defaultPhoneNumber: "+1234567890", context: "navbar" })}>
 *       Open Dialpad
 *     </button>
 *   );
 * }
 * ```
 */
export function useGlobalDialpad() {
    const dispatch = useRVDispatch();
    const dialpadState = useSelector(selectDialpadState);

    const openDialpad = useCallback(
        (options?: { defaultPhoneNumber?: string; context?: GlobalLayoutState["dialpad"]["context"] }) => {
            dispatch(openDialpadAction(options || {}));
        },
        [dispatch]
    );

    const closeDialpad = useCallback(() => {
        dispatch(closeDialpadAction());
    }, [dispatch]);

    return {
        isOpen: dialpadState.isOpen,
        defaultPhoneNumber: dialpadState.defaultPhoneNumber,
        context: dialpadState.context,
        openDialpad,
        closeDialpad,
    };
}
